import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ProjectService } from '@shared/services/project.service';

@Component({
  selector: 'app-new-project-id',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    FormsModule,
  ],
  templateUrl: './new-project-id.component.html',
  styleUrl: './new-project-id.component.scss'
})
export class NewProjectIdComponent {
  public dialogRef: MatDialogRef<NewProjectIdComponent> = inject(MatDialogRef<NewProjectIdComponent>);
  private _projectService: ProjectService = inject(ProjectService);

  public currentId?: string;
  public newId?: string;
  public error?: boolean;

  /**
   * Check if the ID already exists
   *
   * @returns if the project ID is found
   */
  public checkId(): void {
    if (this.newId === undefined) return;
    if (this._projectService.projectList.map((p) => p.proj_id).includes(this.newId)) {
      this.error = true
    } else this.error = false;
  }

  /**
   * Close the dialog
   */
  public close(): void {
    this.dialogRef.close();
  }
}
